import { buildItemDisplayValue } from './displayTemplate';
import { earliestDateValue } from './dateOptions';
import { getFieldValue } from './sort';
import { resolveItemPrimaryDate } from './cards';

const defaultArray = [];

export const getItemDisplayValue = ({
	card,
	elementDefs = defaultArray,
	item = {},
	resolveLookupValue,
	fallback = 'Untitled item',
	emptyElementPlaceholders = true,
}) => {
	const elements = Array.isArray(elementDefs) ? elementDefs : defaultArray;
	const fallbackFields = elements.map(def => def?.name).filter(Boolean);
	const label = buildItemDisplayValue({
		template: card?.displayTemplate,
		elements: item?.elements || {},
		fallbackFields,
		elementDefinitions: elements,
		resolveLookupValue,
		name: item?.name,
		id: item?._id,
		emptyElementPlaceholders,
	});
	return label || item?.name || fallback;
};

/**
 * The raw value of an item's primary date, given its card's spec
 * (utils/cards.js primaryDateForChain / createPrimaryDateResolver): the
 * created or updated timestamp in any of its spellings, the element's
 * stored string — or, under an ordered spec, whichever entry this item has
 * a value for (its terminal's timestamp when none).
 *
 * A date element that holds SEVERAL dates (utils/dateOptions `allowMultiple`)
 * contributes its EARLIEST — a header, a day group and a sort each want one
 * date, and the one they want is the day the record began. Every caller of
 * this gets that reduction for free, which is why the grouping and the
 * headers needed no change of their own.
 */
export const getItemPrimaryDate = (item, spec) => {
	if (!item) return undefined;
	// An ordered spec has no one field: the first populated entry decides,
	// per item (utils/cards.js resolveItemPrimaryDate).
	if (spec?.kind === 'ordered') return resolveItemPrimaryDate(spec, item).value;
	if (!spec?.field) return undefined;
	const raw = getFieldValue(item, spec.field);
	if (!Array.isArray(raw)) return raw;
	return earliestDateValue(spec?.dataType || spec?.element?.dataType, raw);
};

export default getItemDisplayValue;
